import type { Router } from 'vue-router';

/**
 * Access to the app router for modules the router itself (transitively) imports.
 *
 * `@/router` statically imports every view, and views import stores that import
 * `@/tours` — so a tour that does `import router from '@/router'` closes an
 * import cycle. Registering the instance here instead keeps the dependency
 * one-way: `@/router` depends on this module, never the reverse.
 *
 * Components should keep using `useRouter()`; this is for plain modules.
 */
let instance: Router | null = null;

export function setRouter(router: Router): void {
  instance = router;
}

export function getRouter(): Router {
  if (!instance) {
    throw new Error('Router accessed before it was created — call setRouter() first.');
  }
  return instance;
}
